import { MooringArrivalData } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const dataTag = 'MooringArrivalData';
export default class MooringArrivalParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.MOORING_ARRIVAL, FIXED_PROTOCOL_CONTENT_TYPE_IDS.MOORING_ARRIVAL, dataTag, app);
    }
    getPropsMapping() {
        return {
            port: 'port',
            distanceSinceEOSP: 'distanceSinceEOSP',
            freeText: 'freeText',
        };
    }
    createData(props, record) {
        const data = new MooringArrivalData(props.port, props.distanceSinceEOSP, props.freeText);
        const linked = this.getLinked(record);
        if (linked) {
            const link = {
                protocol: linked,
                value: props.port,
            };
            data.port = link;
        }
        return data;
    }
}
//# sourceMappingURL=MooringArrivalParser.js.map